/**
 * Practitioner Directory — Client-side Filter/Search
 * Phase 7 — Progurt
 *
 * Filters directory cards by state, profession, and text search.
 */

(function () {
  'use strict';

  var grid = document.getElementById('prac-grid');
  var filters = document.getElementById('prac-filters');
  var noResults = document.getElementById('prac-no-results');

  if (!grid || !filters) return;

  var cards = grid.querySelectorAll('.practitioner-directory__card');
  var searchInput = filters.querySelector('[data-filter="search"]');
  var stateSelect = filters.querySelector('[data-filter="state"]');
  var professionSelect = filters.querySelector('[data-filter="profession"]');

  function applyFilters() {
    var searchTerm = (searchInput.value || '').toLowerCase().trim();
    var stateFilter = stateSelect.value;
    var professionFilter = professionSelect.value;
    var visibleCount = 0;

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var name = card.dataset.name || '';
      var suburb = card.dataset.suburb || '';
      var state = card.dataset.state || '';
      var profession = card.dataset.profession || '';

      var matchesSearch = !searchTerm ||
        name.indexOf(searchTerm) !== -1 ||
        suburb.indexOf(searchTerm) !== -1;

      var matchesState = !stateFilter || state === stateFilter;
      var matchesProfession = !professionFilter || profession === professionFilter;

      if (matchesSearch && matchesState && matchesProfession) {
        card.hidden = false;
        visibleCount++;
      } else {
        card.hidden = true;
      }
    }

    if (noResults) {
      noResults.hidden = visibleCount > 0;
    }
  }

  searchInput.addEventListener('input', applyFilters);
  stateSelect.addEventListener('change', applyFilters);
  professionSelect.addEventListener('change', applyFilters);
})();

/**
 * State-chip strip + live result count (P12 visual add).
 * Chips drive the existing state <select>; the existing filter logic above
 * does the hiding. This block only syncs chip state and the "Showing X of Y"
 * counter — it does not duplicate or replace the filter logic.
 */
(function () {
  'use strict';

  var grid = document.getElementById('prac-grid');
  var strip = document.getElementById('prac-state-strip');
  if (!grid) return;

  var stateSelect = document.querySelector('[data-filter="state"]');
  var searchInput = document.querySelector('[data-filter="search"]');
  var professionSelect = document.querySelector('[data-filter="profession"]');
  var resultCount = document.getElementById('prac-result-count');
  var cards = grid.querySelectorAll('.practitioner-directory__card');
  var total = cards.length;

  function syncChips() {
    if (!strip || !stateSelect) return;
    var value = stateSelect.value;
    var chips = strip.querySelectorAll('.prac-state-chip');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.toggle('is-active', chips[i].dataset.state === value);
    }
  }

  function updateCount() {
    if (!resultCount) return;
    var visible = 0;
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].hidden) visible++;
    }
    resultCount.innerHTML = 'Showing <strong>' + visible + '</strong> of ' + total;
  }

  if (strip && stateSelect) {
    strip.addEventListener('click', function (e) {
      var chip = e.target.closest('.prac-state-chip');
      if (!chip) return;
      stateSelect.value = chip.dataset.state;
      // Drive the existing filter logic, then sync chip + count.
      stateSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Existing filter listeners run first (registered earlier); these run after,
  // so the cards' hidden state is already current when we sync + count.
  if (stateSelect) stateSelect.addEventListener('change', function () { syncChips(); updateCount(); });
  if (searchInput) searchInput.addEventListener('input', updateCount);
  if (professionSelect) professionSelect.addEventListener('change', updateCount);
})();
